import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@material-ui/lab';
import Backdrop from '@material-ui/core/Backdrop';

const MySpeedDial = ({ classes, actions, icon }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Fragment>
      <Backdrop
        open={open}
        onTouchEnd={handleClose}
        classes={{
          root: classes.backdrop,
        }}
      />
      <SpeedDial
        ariaLabel="floating-btn-with-actions"
        classes={{ root: classes.speedDial, fab: classes.fab }}
        icon={icon || <SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
        data-testid="speed-dial-btn"
      >
        {actions.map((action) => (
          <SpeedDialAction
            data-testid="speed-dial-action"
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={action.onClick || handleClose}
            FabProps={{
              size: 'large',
              classes: { root: classes.action },
            }}
            classes={{
              staticTooltipLabel: classes.staticTooltipLabel,
            }}
          />
        ))}
      </SpeedDial>
    </Fragment>
  );
};

MySpeedDial.defaultProps = {
  classes: {},
  actions: [],
  icon: null,
};

MySpeedDial.propTypes = {
  classes: PropTypes.shape({}),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      onClick: PropTypes.func,
    }),
  ),
  icon: PropTypes.node,
};

export default MySpeedDial;
